import { useNavigate, useParams } from "react-router-dom";
import { useAppServices } from "../../../hook/services";
import { useAgencyInfo } from "../../../context/agency";
import { Icon } from "@iconify/react";
import Select from "react-select";

function App() {
  const navigate = useNavigate();
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  return (
    <>
      {agency?.isPhoneBridgeInstalled ? (
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12">
              <div className="card border-0 shadow-sm overflow-hidden">
                <div
                  className="card-header bg-transparent py-4 px-5 position-relative"
                  style={{
                    borderBottom: "1px solid #eef0f3",
                    background:
                      "linear-gradient(135deg, #f8f9ff 0%, #ffffff 100%)",
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="rounded-3 d-flex align-items-center justify-content-center bg-primary bg-opacity-10"
                      style={{ width: "60px", height: "60px" }}
                    >
                      <Icon
                        icon="mdi:link-variant"
                        width="32"
                        className="text-primary"
                      />
                    </div>
                    <div>
                      <h3 className="fw-bold mb-1 text-dark">
                        Configure Custom Page For Agency
                      </h3>
                      <p className="mb-0 text-muted">
                        Set a custom menu link title that will appear in your
                        agency sidebar.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card-body p-5">
                  <div className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label
                        htmlFor="customMenuLinkTitle"
                        className="form-label fw-semibold mb-0 d-flex align-items-center gap-2"
                      >
                        <Icon
                          icon="mdi:format-title"
                          width="18"
                          className="text-primary"
                        />
                        Custom Menu Link Title
                      </label>
                      <span className="badge bg-primary bg-opacity-10 text-primary fw-normal">
                        Required
                      </span>
                    </div>
                    <div className="input-group input-group-lg">
                      <span className="input-group-text bg-light border-end-0">
                        <Icon
                          icon="mdi:pencil-outline"
                          width="20"
                          className="text-muted"
                        />
                      </span>
                      <input
                        id="customMenuLinkTitle"
                        type="text"
                        className="form-control border-start-0"
                        placeholder="e.g. Phone Bridge"
                        maxLength={40}
                        // value={formValues.customMenuLinkTitle}
                        // onChange={(e) =>
                        //   handleChange("customMenuLinkTitle", e.target.value)
                        // }
                      />
                    </div>
                    <small className="text-muted mt-2 d-flex align-items-center gap-1">
                      <Icon icon="mdi:information-outline" width="14" />
                      This title will be visible to users in the agency
                      navigation menu.
                    </small>
                  </div>

                  <div
                    className="rounded-3 p-3 mb-4 d-flex align-items-start gap-3"
                    style={{
                      background: "#f8f9ff",
                      border: "1px dashed #c7d2fe",
                    }}
                  >
                    <Icon
                      icon="mdi:lightbulb-on-outline"
                      width="22"
                      className="text-primary flex-shrink-0 mt-1"
                    />
                    <div>
                      <h6 className="fw-bold mb-1 text-dark">Tip</h6>
                      <p className="mb-0 text-muted small">
                        Use a short, descriptive title (up to 40 characters).
                        You can update it later from this page.
                      </p>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end align-items-center gap-3 pt-2 border-top pt-4">
                    <button
                      type="button"
                      className="btn btn-lg btn-secondary px-5 py-3 fw-semibold shadow-sm d-flex align-items-center"
                      style={{ borderRadius: "12px" }}
                      // onClick={configureCustomMenuLink}
                    >
                      <Icon
                        icon="mdi:link-plus"
                        width="22"
                        className="me-2"
                      />
                      Create Custom Menu Link
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-12 col-md-12">
              {/* Main Install Card */}
              <div className="card border-0 shadow-sm overflow-hidden">
                <div
                  className="card-header bg-transparent py-4 px-5 position-relative"
                  style={{
                    borderBottom: "1px solid #eef0f3",
                  }}
                >
                  <div className="d-flex align-items-center gap-3 position-relative">
                    <div
                      className="rounded-3 d-flex align-items-center justify-content-center bg-primary bg-opacity-10"
                      style={{
                        width: "60px",
                        height: "60px",
                      }}
                    >
                      <Icon
                        icon="mdi:phone-in-talk"
                        width="32"
                        className="text-primary"
                      />
                    </div>
                    <div>
                      <h3 className="fw-bold mb-1 text-dark">
                        Install Phone Bridge App
                      </h3>
                      <p className="mb-0 text-muted">
                        Follow these steps to enable Phone Bridge on your
                        location
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card-body p-5">
                  <div className="text-center mb-5">
                    <h4 className="fw-bold mb-2">
                      Get Started with Phone Bridge
                    </h4>
                    <p className="text-muted mb-0">
                      Install the app on the location where you want to use the
                      Phone Bridge feature.
                    </p>
                  </div>

                  {/* Step-by-step Instructions */}
                  <div className="row g-4 mb-5">
                    <div className="col-md-4">
                      <div
                        className="p-4 h-100 rounded-4 border position-relative"
                        style={{ background: "#f8f9ff" }}
                      >
                        <div
                          className="position-absolute top-0 start-0 translate-middle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold"
                          style={{ width: "36px", height: "36px" }}
                        >
                          1
                        </div>
                        <div className="text-center pt-2">
                          <div
                            className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                            style={{ width: "70px", height: "70px" }}
                          >
                            <Icon
                              icon="mdi:cursor-default-click"
                              width="36"
                              className="text-primary"
                            />
                          </div>
                          <h6 className="fw-bold mb-2">
                            Click Install Button
                          </h6>
                          <p className="text-muted small mb-0">
                            Hit the install button below to open the GoHighLevel
                            marketplace.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div
                        className="p-4 h-100 rounded-4 border position-relative"
                        style={{ background: "#f8f9ff" }}
                      >
                        <div
                          className="position-absolute top-0 start-0 translate-middle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold"
                          style={{ width: "36px", height: "36px" }}
                        >
                          2
                        </div>
                        <div className="text-center pt-2">
                          <div
                            className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                            style={{ width: "70px", height: "70px" }}
                          >
                            <Icon
                              icon="mdi:map-marker-check"
                              width="36"
                              className="text-primary"
                            />
                          </div>
                          <h6 className="fw-bold mb-2">Choose Location</h6>
                          <p className="text-muted small mb-0">
                            Select the location where you want to activate Phone
                            Bridge features.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div
                        className="p-4 h-100 rounded-4 border position-relative"
                        style={{ background: "#f8f9ff" }}
                      >
                        <div
                          className="position-absolute top-0 start-0 translate-middle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold"
                          style={{ width: "36px", height: "36px" }}
                        >
                          3
                        </div>
                        <div className="text-center pt-2">
                          <div
                            className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                            style={{ width: "70px", height: "70px" }}
                          >
                            <Icon
                              icon="mdi:check-decagram"
                              width="36"
                              className="text-primary"
                            />
                          </div>
                          <h6 className="fw-bold mb-2">Authorize & Finish</h6>
                          <p className="text-muted small mb-0">
                            Approve the required permissions and you're ready to
                            go.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Important Note */}
                  <div
                    className="rounded-4 p-4 mb-4 border-start border-4 border-warning"
                    style={{ background: "#fff8e1" }}
                  >
                    <div className="d-flex">
                      <div className="me-3">
                        <Icon
                          icon="mdi:alert-circle"
                          width="28"
                          className="text-warning"
                        />
                      </div>
                      <div>
                        <h6 className="fw-bold mb-1">Important</h6>
                        <p className="mb-0 text-muted">
                          <strong className="text-dark">
                            Make sure to install the app on the location where
                            you want the Phone Bridge feature.
                          </strong>{" "}
                          Phone Bridge will be linked to the selected location.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Action Button */}
                  <div className="text-center pt-2">
                    <a
                      href={`https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${"env.APP_URL"}/integrations%2Fsupport&client_id=69452594b480b1848b1bf78d-mjcpz80c&scope=conversations.readonly+conversations.write+conversations%2Fmessage.readonly+conversations%2Fmessage.write+conversations%2Flivechat.write+contacts.readonly+contacts.write+locations%2FcustomFields.readonly+locations%2FcustomFields.write&version_id=69452594b480b1848b1bf78d`}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-lg px-5 py-3 btn-secondary text-decoration-none fw-semibold shadow"
                      style={{
                        // background:
                        //   "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
                        borderRadius: "12px",
                      }}
                    >
                      <Icon
                        icon="mdi:download"
                        width="22"
                        className="me-2"
                      />
                      Install Phone Bridge App
                    </a>
                    <p className="text-muted small mt-3 mb-0">
                      You will be redirected to GoHighLevel to complete the
                      installation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default App;
